export const selectColumnListDomainSkillsTable = [
  { optionKey: "Select Column", optionValue: "" },
  { optionKey: "Id", optionValue: "id" },
  { optionKey: "Domain Skill", optionValue: "name" },
  { optionKey: "Description", optionValue: "description" },
];

export const sortByOptionDomainSkillsTable = [
  { optionKey: "Sort By Option", optionValue: "" },
  { optionKey: "Sort Ascending", optionValue: "asc" },
  { optionKey: "Sort Descending", optionValue: "dsc" },
];
